import { render } from "./ListTax.vue?vue&type=template&id=311dd2b7&scoped=true"
import script from "./ListTax.vue?vue&type=script&lang=js"
export * from "./ListTax.vue?vue&type=script&lang=js"

import "./ListTax.vue?vue&type=style&index=0&id=311dd2b7&scoped=true&lang=css"

import exportComponent from "H:\\Productions\\CS\\inc\\helpers\\cs-restaurants\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311dd2b7"]])

export default __exports__